








import {
  FeedbackType,
} from '@/store/modules/feedback/types'
import {
  Component,
  Vue,
} from 'vue-property-decorator'

const icons: IDictionary < string > = {
  [FeedbackType.CREATE_SUCCESS]: 'thumb_up',
  [FeedbackType.CREATE_FAIL]: 'bug_report',
  [FeedbackType.ERROR]: 'error',
  [FeedbackType.NO_FEEDBACK]: '',
}

@Component < ActionFeedback > ({})
export default class ActionFeedback extends Vue {
  get feedbackMessage(): string {
    const message = this.$store.getters['feedback/message']
    return message
  }

  get isVisible(): boolean {
    return this.$store.getters['feedback/isVisible']
  }

  get icon(): string {
    const feedbackType = this.$store.getters['feedback/type']
    return icons[feedbackType]
  }
}
